module.exports = __webpack_public_path__ + "static/media/solar_street.d7532554.png";